
import { defineComponent, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { IToken } from '@/types/interfaces';
/* eslint-disable import/no-cycle */
import AuthService from '@/modules/auth/services/AuthService';
import AppLoader from '@/components/UI/AppLoader.vue';
import MonitoringService from '@/services/MonitoringService';

export default defineComponent({
  components: { AppLoader },
  setup() {
    const router = useRouter();
    const route = useRoute();

    onMounted(() => {
      const tokenParam = route.query.token?.toString();
      AuthService.confirmPasswordChange({ token: tokenParam } as IToken).then((response) => {
        if (response.success) {
          router.push('/password-reset-change');
        } else {
          router.push('/password-reset-error');
        }
      });
      MonitoringService.sendPageMountedSpeed();
    });
  },
});
